import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type UseCopyToClipboardArgs = {
  text: string;
  timeout?: number;
};

export const useCopyToClipboard = ({ text, timeout = 1000 }: UseCopyToClipboardArgs) => {
  const { t } = useTranslation('sharedComponents');
  const [copying, setCopying] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(text);
    setCopying(true);
    setTimeout(() => {
      setCopying(false);
    }, timeout);
  };
  const message = copying ? t('shared.promoBanner.copied') : text;
  return [message, copyToClipboard];
};
